import React from 'react';
import { Route } from 'react-router-dom';

interface AppRouteInterface {
  component: React.FC,
  path: string,
  exact?: any,
  layout: React.FC,
  isProvince?: boolean
}

const AppRoute: React.FC<AppRouteInterface> = props => {

  const {
    component: Component,
    layout: Layout,
    path,
    exact,
    isProvince
  } = props;


  return (
    <Route
      path={path}
      render={() => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
      {...exact}
    />
  )
}

export default AppRoute;